import { Textarea } from "@/components/ui/textarea";
import { MessageTemplates } from "@/components/agendamentos/MessageTemplates";

interface MessageInputProps {
  value: string;
  onChange: (value: string) => void;
  onTemplateSelect: (template: string) => void;
}

export const MessageInput = ({ value, onChange, onTemplateSelect }: MessageInputProps) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <label className="text-sm font-medium">Mensagem</label>
    </div>
    <MessageTemplates onSelectTemplate={onTemplateSelect} />
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={4}
      placeholder="Digite sua mensagem..."
    />
  </div>
);